import { Flex, Image } from "antd";
import { Fade } from "react-awesome-reveal";
import img from "../images/tasybayev.jpeg";
import MyText from "../../../components/UI/Text/MyText";
import { clrs } from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import { Link } from "react-router-dom";
import { LinkOutlined } from "@ant-design/icons";
import React from "react";
import IntlMessage from "../../../components/IntlMessage/IntlMessage";

export const PersonTasybayev = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40} wrap="wrap">
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img} width={240} preview={false} style={{ borderRadius: 16 }} />
                </Fade>
                <Flex style={{ flex: 1, minWidth: 200, position: "relative" }} vertical>
                    <MyText strong size={"large"}><IntlMessage id={'team.person.tasybayev.fullName'} /></MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>
                        <IntlMessage id={'team.person.tasybayev.title'} />
                    </MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <Flex gap={12} wrap={"wrap"} vertical>
                        <Link target={"_blank"} to={'https://orcid.org/0009-0004-3180-6207'}>
                            <MyText><LinkOutlined /> ORCID</MyText>
                        </Link>
                    </Flex>
                    <br />
                    <MyText strong size={"small"}><IntlMessage id={'team.label.workplace'} /></MyText>
                    <MyText><IntlMessage id={'team.person.tasybayev.workplace'} /></MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}><IntlMessage id={'team.label.roleInProject'} /></MyText>
                <MyText size={"small"} italic><IntlMessage id={'team.person.tasybayev.role'} /></MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - <IntlMessage id={'team.person.tasybayev.role.1'} />
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - <IntlMessage id={'team.person.tasybayev.role.2'} />
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - <IntlMessage id={'team.person.tasybayev.role.3'} />
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}><IntlMessage id={'team.label.justification'} /></MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    <IntlMessage id={'team.person.tasybayev.justification'} />
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}><IntlMessage id={'team.label.projects'} /></MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - <IntlMessage id={'team.person.tasybayev.projects.1'} />
                </MyText>
            </Flex>
        </Flex>
    );
};
